<template>
    <div class="new-agency">
        <div class="page-header">
			<h1>Onboard Agency</h1>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
				<el-breadcrumb-item>Agency</el-breadcrumb-item>
				<el-breadcrumb-item>Onboard</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
        <work-in-progress />
    </div>
</template>

<script>
export default {
    name: 'NewAgency'
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

</style>



// WEBPACK FOOTER //
// src/views/agency/NewAgency.vue